class ABFeaturedStories {
  constructor(slider) {
    this.slider = slider;
    this.sectionId = slider.dataset.sectionId;
    this.initSwiper();
    this.bindATC();
  }

  initSwiper() {
    if (typeof Swiper === 'undefined') return;

    const showArrows = this.slider.dataset.showArrows === 'true';
    const slidesMobile = Number(this.slider.dataset.slidesMobile || 1.1);
    const slidesTablet = Number(this.slider.dataset.slidesTablet || 2.2);
    const slidesDesktop = Number(this.slider.dataset.slidesDesktop || 3.1);
    const space = Number(this.slider.dataset.space || 24);

    const navPrev = this.slider.querySelector('.swiper-button-prev');
    const navNext = this.slider.querySelector('.swiper-button-next');

    this.swiperInstance = new Swiper(this.slider, {
      slidesPerView: slidesMobile,
      spaceBetween: space,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      centeredSlides: false,
      navigation: showArrows
        ? {
            nextEl: navNext,
            prevEl: navPrev,
          }
        : undefined,
      breakpoints: {
        750: {
          slidesPerView: slidesTablet,
        },
        1100: {
          slidesPerView: slidesDesktop,
        },
      },
    });
  }

  bindATC() {
    this.slider.addEventListener('click', (e) => {
      const btn = e.target.closest('.ab-featured-stories__btn--atc');
      if (!btn || !this.slider.contains(btn)) return;
      if (btn.classList.contains('is-disabled') || btn.hasAttribute('disabled')) return;
      if (btn.classList.contains('loading')) return;

      e.preventDefault();
      this.addToCart(btn);
    });
  }

  async addToCart(btn) {
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const btnText = btn.querySelector('.ab-featured-stories__btn-text');
    const originalText = btnText ? (btnText.textContent.trim() || 'Shop Now') : 'Shop Now';

    btn.classList.add('loading');
    btn.setAttribute('aria-disabled', 'true');

    const cartComponent = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    if (cartComponent && typeof cartComponent.getSectionsToRender === 'function') {
      try {
        const sectionIds = cartComponent.getSectionsToRender().map((s) => s.id);
        formData.append('sections', sectionIds.join(','));
        formData.append('sections_url', window.location.pathname);
      } catch (_) {}
    }

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript',
        },
        body: formData,
      });

      const data = await response.json();

      if (!response.ok) {
        alert(data.description || data.message || 'Could not add item to cart.');
        return;
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'ab-featured-stories',
          productVariantId: variantId,
          cartData: data,
        });
      }

      if (cartComponent && typeof cartComponent.renderContents === 'function') {
        try {
          cartComponent.renderContents(data);
        } catch (_) {
          await this.refreshCartBubble();
        }
      } else {
        await this.refreshCartBubble();
      }

      if (btnText) {
        btnText.textContent = 'Added!';
        setTimeout(() => {
          btnText.textContent = originalText;
        }, 2000);
      }
    } catch (_) {
    } finally {
      btn.classList.remove('loading');
      btn.removeAttribute('aria-disabled');
    }
  }

  async refreshCartBubble() {
    try {
      const res = await fetch(`${window.Shopify.routes.root}cart.js`);
      const cart = await res.json();
      document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
        const span = bubble.querySelector('span[aria-hidden="true"]');
        if (span) span.textContent = cart.item_count;
        bubble.classList.remove('hidden');
      });
    } catch (_) {}
  }
}

function initABFeaturedStories() {
  document.querySelectorAll('.ab-featured-stories__slider[data-section-id]').forEach((slider) => {
    if (!slider.__abFeaturedStories) {
      slider.__abFeaturedStories = new ABFeaturedStories(slider);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initABFeaturedStories);
} else {
  initABFeaturedStories();
}

document.addEventListener('shopify:section:load', (e) => {
  const slider = e.target.querySelector('.ab-featured-stories__slider[data-section-id]');
  if (slider) {
    slider.__abFeaturedStories = new ABFeaturedStories(slider);
  }
});
